<div>
  <div class="error-header">
    <div>
      <img id="img_logo" src="./assets/img/PSS_logo.png" alt="Itaú logo" />
    </div>
  </div>
  <div class="error-container">
    <div>
      <div class="error-message">
        <div class="error-title"><span class="error-title title">Login Inválido</span></div>
        <div>
          <span class="error-description">
            Por favor, tente novamente mais tarde.<br />
            Se o problema persistir, contate seu canal de atendimento.
          </span>
        </div>
      </div>
      <div class="error-bottom">
        <a href="{{ linkInitialPage }}"><span class="itau-text-bold">Retornar para a página inicial</span></a>
      </div>
    </div>
  </div>
</div>